module.exports = __webpack_public_path__ + "img/icon-partner.e3502282.png";